import { render, staticRenderFns } from "./citationTraceEn.vue?vue&type=template&id=6afbf707&scoped=true"
import script from "./citationTraceEn.vue?vue&type=script&lang=js"
export * from "./citationTraceEn.vue?vue&type=script&lang=js"
import style0 from "./citationTraceEn.vue?vue&type=style&index=0&id=6afbf707&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afbf707",
  null
  
)

export default component.exports